module.exports = __webpack_public_path__ + "static/media/387.0926f870.webp";